import { render, staticRenderFns } from "./PdfPreview.vue?vue&type=template&id=05b0719e&"
import script from "./PdfPreview.vue?vue&type=script&lang=js&"
export * from "./PdfPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports